import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

const REPORTS_ENVS = {
  //dev: { url: 'http://localhost:5141', key: 'dev123!' },
  dev: { url: 'https://va-apis.mobydyg.com', key: 'c95BhsUH77Qv0DbcnL5WyXu3htSpLzKhoL3bt6QjX6R9j1E2Q4J9B6tpY4xc'  },
  prod: { url: 'https://va-apis.mobydyg.com', key: 'c95BhsUH77Qv0DbcnL5WyXu3htSpLzKhoL3bt6QjX6R9j1E2Q4J9B6tpY4xc' }
};

export interface ReportAccount {
  accountId: string;
  name: string;
}

export interface MonthlyConversationReport {
  month: string;
  accountId: string;
  accountName: string;
  conversationCount: number;
  messageCount: number;
  inboundMessageCount: number;
  outboundMessageCount: number;
  channels: ReportChannel[];
}

export interface ReportChannel {
  channel: string;
  messageCount: number;
  inboundMessageCount: number;
  outboundMessageCount: number;
}

export interface ReportsResponse {
  accounts: ReportAccount[];
  reports: MonthlyConversationReport[];
}

export interface ReportsQuery {
  from?: string;
  to?: string;
  accountId?: string;
  channels?: string[];
}

@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  private readonly activeEnv: 'dev' | 'prod' = environment.production || environment.stage === 'prod' ? 'prod' : 'dev';

  private async request<T>(path: string, options: RequestInit = {}): Promise<T> {
    const env = REPORTS_ENVS[this.activeEnv];
    const url = `${env.url}${path}`;
    const config: RequestInit = {
      ...options,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-ApiKey': env.key
      }
    };

    const response = await fetch(url, config);
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || `[ReportsService] ${response.status} ${response.statusText}`);
    }

    if (response.status === 204 || response.headers.get('content-length') === '0') {
      return undefined as T;
    }

    return response.json() as Promise<T>;
  }

  getReports(query: ReportsQuery = {}): Promise<ReportsResponse> {
    const params = new URLSearchParams();

    if (query.from) {
      params.set('from', query.from);
    }

    if (query.to) {
      params.set('to', query.to);
    }

    if (query.accountId) {
      params.set('accountId', query.accountId);
    }

    for (const channel of query.channels ?? []) {
      params.append('channels', channel);
    }

    const queryString = params.toString();
    const path = queryString ? `/reports?${queryString}` : '/reports';

    return this.request<ReportsResponse>(path)
      .then(response => ({
        accounts: Array.isArray(response?.accounts) ? response.accounts : [],
        reports: Array.isArray(response?.reports)
          ? response.reports.map(report => ({
              ...report,
              conversationCount: Number(report?.conversationCount) || 0,
              messageCount: Number(report?.messageCount) || 0,
              inboundMessageCount: Number(report?.inboundMessageCount) || 0,
              outboundMessageCount: Number(report?.outboundMessageCount) || 0,
              channels: Array.isArray(report?.channels)
                ? report.channels.map(channel => ({
                    ...channel,
                    channel: String(channel?.channel ?? ''),
                    messageCount: Number(channel?.messageCount) || 0,
                    inboundMessageCount: Number(channel?.inboundMessageCount) || 0,
                    outboundMessageCount: Number(channel?.outboundMessageCount) || 0
                  }))
                : []
            }))
          : []
      }));
  }
}
